<template>
  <div>
    <div v-if="!busy && this.userData">
      <v-card>
        <v-toolbar
          light
          color="white"
          class="elevation-2"
        >
          <v-toolbar-title>
            Mój profil
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            @click="showPasswordDialog"
            color="primary">
            Zmień hasło
          </v-btn>
        </v-toolbar>
        <v-layout wrap :class="paddingClass">
          <v-flex xs12 md6>

            <v-layout py-2 wrap>
              <v-flex xs12 pb-2 pt-2>
                <span class="title grey--text ">Dane użytkownika: </span>
              </v-flex>
            </v-layout>

            <v-layout py-2 wrap v-if="hasName">
              <v-flex xs12 sm3>
                <span class="grey--text text--darken-2 body-1">Nazwa: </span>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="body-2">{{name}}</span>
              </v-flex>
            </v-layout>

            <v-layout py-2 wrap v-if="hasEmail">
              <v-flex xs12 sm3>
                <span class="grey--text text--darken-2 body-1">Adres e-mail: </span>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="body-2" v-html="hasEmail"></span>
              </v-flex>
            </v-layout>

            <v-layout py-2 wrap v-if="userData.status_txt">
              <v-flex xs12 sm3>
                <span class="grey--text text--darken-2 body-1">Status: </span>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="body-2">{{userData.status_txt}}</span>
              </v-flex>
            </v-layout>

            <v-layout py-2 wrap v-if="userData.role_txt">
              <v-flex xs12 sm3>
                <span class="grey--text text--darken-2 body-1">Rodzaj konta: </span>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="body-2">{{userData.role_txt}}</span>
              </v-flex>
            </v-layout>

            <v-layout py-2 wrap v-if="userData.created_at">
              <v-flex xs12 sm3>
                <span class="grey--text text--darken-2 body-1">Data utworzenia: </span>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="body-2">{{userData.created_at}}</span>
              </v-flex>
            </v-layout>


          </v-flex>

          <v-flex xs12 md6>

            <v-layout py-2 wrap>
              <v-flex xs12 pb-2 pt-2>
                <span class="title grey--text">Dane autentykacyjne: </span>
              </v-flex>
            </v-layout>

            <v-layout py-2 wrap v-if="userData.pin">
              <v-flex xs12 sm3>
                <span class="grey--text text--darken-2 body-1">Kod PIN:</span>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="body-2">{{userData.pin}}</span>
              </v-flex>
            </v-layout>

            <v-layout py-2 wrap v-if="userData.email">
              <v-flex xs12 sm3>
                <span class="grey--text text--darken-2 body-1">Login:</span>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="body-2">{{userData.email}}</span>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="mt-4">
        <v-toolbar
          light
          color="white"
          class="elevation-2"
        >
          <v-toolbar-title>
            Google Drive
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-tooltip left>
            <v-btn
              icon
              slot="activator"
              @click="storeGdDialog"
            >
              <v-icon
                color="primary"
              >edit</v-icon>
            </v-btn>
            <span>Edytuj Google Drive</span>
          </v-tooltip>

        </v-toolbar>
        <v-layout :class="paddingClass">
          <v-flex xs12 lg8 v-if="showGdSection">

            <v-layout py-2 wrap v-if="userData.gd_client_id">
              <v-flex xs12 sm3>
                <span class="grey--text text--darken-2 body-1">Client ID: </span>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="body-2 white-space-wrap">{{userData.gd_client_id}}</span>
              </v-flex>
            </v-layout>

            <v-layout py-2 wrap v-if="userData.gd_client_secret">
              <v-flex xs12 sm3>
                <span class="grey--text text--darken-2 body-1">Client Secret: </span>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="body-2 white-space-wrap">{{userData.gd_client_secret}}</span>
              </v-flex>
            </v-layout>

            <v-layout py-2 wrap v-if="userData.gd_refresh_token">
              <v-flex xs12 sm3>
                <span class="grey--text text--darken-2 body-1">Refresh Token: </span>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="body-2 white-space-wrap">{{userData.gd_refresh_token}}</span>
              </v-flex>
            </v-layout>

            <v-layout py-2 wrap v-if="userData.gd_folder_id">
              <v-flex xs12 sm3>
                <span class="grey--text text--darken-2 body-1">Folder ID: </span>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="body-2 white-space-wrap">{{userData.gd_folder_id}}</span>
              </v-flex>
            </v-layout>

          </v-flex>

          <v-flex xs12 v-if="!showGdSection" py-4>
            <p class="mb-0 grey--text text--darken-1 subheading font-weight-bold">
              Brak synchronizacji z Google Drive
            </p>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions :class="paddingClass">
          <v-spacer></v-spacer>
          <v-btn
            v-if="showGdSection"
            color="primary"
            @click="removeGd"
          >
            Usuń
          </v-btn>
          <v-btn
            v-if="!showGdSection"
            color="primary"
            @click="storeGdDialog"
          >
            Dodaj
          </v-btn>
        </v-card-actions>
      </v-card>
      <GoogleDriveDialog :gdProfileData="gdData" @refresh-profile="getUserProfile" />
      <PasswordDialog />
      <GoogleDriveRemoveDialog @refresh-profile="getUserProfile" />
    </div>

    <v-card class="mb-4" v-if="busy">
      <div class="users_loader">
        <div class="py-4 text-xs-center">
          <v-progress-circular
            :size="30"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { userProfile } from '../../repository/users';
import PasswordDialog from './Dialog/PasswordDialog.vue';
import GoogleDriveDialog from './Dialog/GoogleDriveDialog.vue';
import GoogleDriveRemoveDialog from './Dialog/RemoveGoogleDriveDialog.vue';

export default {
  name: 'profile-details',
  data: () => ({
    busy: false,
    userData: null,
  }),
  components: {
    PasswordDialog,
    GoogleDriveDialog,
    GoogleDriveRemoveDialog,
  },
  computed: {
    hasName() {
      return this.userData.first_name || this.userData.last_name;
    },
    name() {
      return `${this.userData.first_name} ${this.userData.last_name}`;
    },
    hasEmail() {
      const mail = this.userData.email;
      const mailHtml = `<a href="mailto:${mail}">${mail}</a>`;
      return mail ? mailHtml : false;
    },
    gdData() {
      return {
        gd_client_id: this.userData.gd_client_id || null,
        gd_client_secret: this.userData.gd_client_secret || null,
        gd_refresh_token: this.userData.gd_refresh_token || null,
        gd_folder_id: this.userData.gd_folder_id || null,
      };
    },
    showGdSection() {
      return this.userData.gd_client_id
        || this.userData.gd_client_secret
        || this.userData.gd_refresh_token
        || this.userData.gd_folder_id;
    },
    paddingClass() {
      return this.$vuetify.breakpoint.smAndDown ? 'px-3 py-3' : 'px-4 py-4';
    },
  },
  methods: {
    ...mapActions('users', [
      'setDialogVisbility',
    ]),
    storeGdDialog() {
      this.setDialogVisbility({
        type: 'google-drive',
      });
    },
    async getUserProfile() {
      this.busy = true;
      const profileData = await userProfile();
      this.userData = profileData.data.data.profile;
      this.busy = false;
    },
    showPasswordDialog() {
      this.setDialogVisbility({
        type: 'change-password',
      });
    },
    async removeGd() {
      this.setDialogVisbility({
        type: 'google-drive-remove',
      });
    },
  },
  mounted() {
    this.getUserProfile();
  },
};
</script>
